<table *ngIf="examStats && examStats.length > 0" mat-table [dataSource]="examStats"
       class="mat-elevation-z2 full-width results-table">

  <!-- School Name Column -->
  <ng-container matColumnDef="school-name">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span i18n="Users List|Users List item 'school' title@@users-list-item-school-title">School:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell word-wrap">
      {{element.schoolName}}
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span i18n="General|Totals term@@general-totals-term" class="mat-body-2">Totals:</span>
    </td>
  </ng-container>

  <!-- School Address Column -->
  <ng-container matColumnDef="school-address">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span i18n="School details|School address@@school-details-address-sub-title">
        School address:
      </span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell word-wrap">
      {{element.schoolAddress}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- School Region Column -->
  <ng-container matColumnDef="school-region-name">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span i18n="Users List|Users List item 'region' title@@users-list-item-region-title">Region:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell word-wrap">
      {{element.schoolRegionName}}
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- Excellent Results Column -->
  <ng-container matColumnDef="excellent-count">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>{{localizeExamGrade(examGrades.excellent)}}:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell">
      <span>{{element.excellentResults || 0}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2">{{countTotals(examGrades.excellent)}}</span>
    </td>
  </ng-container>

  <!-- Excellent (+7%) Results Column -->
  <ng-container matColumnDef="excellent-count-padded">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>{{localizeExamGrade(examGrades.excellent)}} (+7%):</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell text-disabled-color">
      <span>{{padValue(element.excellentResults || 0, 1.07)}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2 text-disabled-color">{{countTotals(examGrades.excellent, 1.07)}}</span>
    </td>
  </ng-container>

  <!-- Good Results Column -->
  <ng-container matColumnDef="good-count">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>{{localizeExamGrade(examGrades.good)}}:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell">
      <span>{{element.goodResults || 0}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2">{{countTotals(examGrades.good)}}</span>
    </td>
  </ng-container>

  <!-- Good (+10%) Results Column -->
  <ng-container matColumnDef="good-count-padded">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>{{localizeExamGrade(examGrades.good)}} (+10%):</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell text-disabled-color">
      <span>{{padValue(element.goodResults || 0, 1.1)}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2 text-disabled-color">{{countTotals(examGrades.good, 1.1)}}</span>
    </td>
  </ng-container>

  <!-- Average Results Column -->
  <ng-container matColumnDef="average-count">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>{{localizeExamGrade(examGrades.average)}}:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell">
      <span>{{(element.averageResults || 0) + (element.skipped || 0)}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2">{{countTotals(examGrades.average)}}</span>
    </td>
  </ng-container>

  <!-- Average (+10%) Results Column -->
  <ng-container matColumnDef="average-count-padded">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>{{localizeExamGrade(examGrades.average)}} (+10%):</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell text-disabled-color">
      <span>{{padValue((element.averageResults || 0) + (element.skipped || 0), 1.1)}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2 text-disabled-color">{{countTotals(examGrades.average, 1.1)}}</span>
    </td>
  </ng-container>

  <!-- Participants Count Column -->
  <ng-container matColumnDef="participants">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span
        i18n="Exam region schools results|Total participants count title@@exam-region-schools-result-total-participants-count-title">Total participants:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell">
      <span>{{(element.excellentResults || 0) + (element.goodResults || 0) + (element.averageResults || 0) + (element.skipped || 0)}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2">{{countParticipantsTotal()}}</span>
    </td>
  </ng-container>


  <!-- Participants (+2%) Count Column -->
  <ng-container matColumnDef="participants-padded">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>
        <ng-container
          i18n="Exam region schools results|Total participants count title@@exam-region-schools-result-total-participants-count-title">Total participants:</ng-container> (+2%):</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell text-disabled-color">
      <span>{{padValue((element.excellentResults || 0) + (element.goodResults || 0) + (element.averageResults || 0) + (element.skipped || 0), 1.02)}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2 text-disabled-color">{{countParticipantsTotal(1.02)}}</span>
    </td>
  </ng-container>

  <!-- Teachers Column -->
  <ng-container matColumnDef="teachers-count">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span i18n="Exam region schools results|Teachers count title@@exam-region-schools-result-teachers-count-title">Teachers:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell">
      <span>{{element.teachers || 0}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2">{{countTeachersTotal()}}</span>
    </td>
  </ng-container>

  <!-- Teachers (+2%) Column -->
  <ng-container matColumnDef="teachers-count-padded">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span>
        <ng-container
          i18n="Exam region schools results|Teachers count title@@exam-region-schools-result-teachers-count-title">Teachers:</ng-container> (+2%):</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell text-disabled-color">
      <span>{{padValue(element.teachers || 0, 1.02)}}</span>
    </td>
    <td mat-footer-cell *matFooterCellDef>
      <span class="mat-body-2 text-disabled-color">{{countTeachersTotal(1.02)}}</span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="mobileView ? mobileColumnsToDisplay : columnsToDisplay;"></tr>
  <tr mat-row *matRowDef="let element; columns: mobileView ? mobileColumnsToDisplay : columnsToDisplay;"
      class="question-answer-row"></tr>
  <tr mat-footer-row *matFooterRowDef="mobileView ? mobileColumnsToDisplay : columnsToDisplay"></tr>
</table>
